<template>
  <div
    class="input-row"
    :class="[
      className,
      {
        'input-row--error': error,
        'input-row--empty': isEmpty,
        'input-row--label-top': labelPos === 'top',
        'input-row--label-above': labelPos === 'above',
        'input-row--icon--left': hasIconLeft,
        'input-row--icon--right': hasIconRight,
        'input-row--disabled': disabled,
      },
    ]"
  >
    <slot name="icon"></slot>
    <label v-if="label" :for="`${name}`">{{ label }}</label>
    <slot name="input"></slot>
    <slot name="icon-right"></slot>
  </div>
  <div class="input-row--error-text" v-if="error">
    {{ error }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const model = defineModel<any>();

const props = withDefaults(
  defineProps<{
    className?: string;
    label?: string;
    labelPos?: string;
    name?: string;
    error?: string;
    hasIconLeft?: boolean;
    hasIconRight?: boolean;
    placeholder?: string;
    isExpanded?: boolean;
    disabled?: boolean;
  }>(),
  {
    className: '',
    label: '',
    labelPos: 'top',
    disabled: false,
    name: '',
    error: '',
    hasIconLeft: false,
    hasIconRight: false,
    placeholder: '',
    isExpanded: false,
  },
);

const isEmpty = computed(() => {
  return (
    (props.placeholder == '' || !props.placeholder) &&
    (model.value === '' ||
      model.value === undefined ||
      model.value === null ||
      model.value?.length === 0)
  );
});
</script>
